import React, { useState } from 'react';
import PropTypes from 'prop-types';
import YouTube from 'react-youtube';
import A11yFontIcon from 'components/A11yFontIcon';
import TextButton from 'components/TextButton';
import BackgroundMusic from 'utils/BackgroundMusic';
import './VideoEmbed.css';

const DEFAULT_OPTS = {
  playerVars: {
    autoplay: 1
  }
};

function VideoEmbed({
  videoId,
  thumbnail,
  title,
  deactivateOnEnd,
  onEnd,
  onPlay,
  onPause,
  ...rest
}) {
  const [active, setActive] = useState(false);
  const [playing, setPlaying] = useState(false);

  if (!active) {
    return (
      <div className="video-embed">
        <TextButton
          onClick={() => setActive(true)}
          aria-label={title ? `Play Video: ${title}` : 'Play video'}
        >
          <img
            src={
              thumbnail || `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`
            }
            referrerPolicy="origin"
            alt=""
          />
          <A11yFontIcon icon="youtube-play" className="play-icon" alt="" />
        </TextButton>
      </div>
    );
  }

  const handlePlay = () => {
    setPlaying(true);
    onPlay && onPlay();
  };

  const handlePause = () => {
    setPlaying(false);
    onPause && onPause();
  };

  const handleOnEnd = () => {
    setPlaying(false);
    if (deactivateOnEnd) {
      setActive(false);
    }
    onEnd && onEnd();
  };

  return (
    <>
      {!!playing && <BackgroundMusic priority={10} options={null} />}
      <YouTube
        key={videoId}
        videoId={videoId}
        containerClassName="video-embed"
        opts={DEFAULT_OPTS}
        onPlay={handlePlay}
        onPause={handlePause}
        onEnd={handleOnEnd}
        {...rest}
      />
    </>
  );
}

VideoEmbed.propTypes = {
  videoId: PropTypes.string,
  thumbnail: PropTypes.string,
  title: PropTypes.string,
  deactivateOnEnd: PropTypes.bool,
  onPlay: PropTypes.func,
  onPause: PropTypes.func,
  onEnd: PropTypes.func
};

export default VideoEmbed;
